import { ConfigType, EnvironmentType } from './types';

const config: ConfigType = {
  ENVIRONMENT: EnvironmentType.PRODUCTION,
  API_KEY: 'AIzaSyAw3NsrUt4wRP1Ufgel3xbT6GtSSiS47wM',
  AUTH_DOMAIN: 'jigsaw-puzzle-universe.firebaseapp.com',
  PROJECT_ID: 'jigsaw-puzzle-universe',
  STORAGE_BUCKET: 'jigsaw-puzzle-universe.appspot.com',
  MESSAGING_SENDER_ID: '177017120417',
  APP_ID: '1:177017120417:web:6bb87451dc9c362718b2e0',
  RECAPTCHA_KEY: '6LdPjoUpAAAAAGIgSOeBnMR91D8Xgeg04O5MyiJl',
};

export default config;
